import { useCheckoutStore } from "@/store/checkout";
import { useClientStore } from "@/store/client";
import { useMagasinStore } from "@/store/magasin";

export const usePageCommanderConfirmationEnAttente = () => {

  const magasinStore = useMagasinStore();
  const clientStore = useClientStore();
  const checkoutStore = useCheckoutStore();

  const { telephone, name } = storeToRefs(magasinStore);
  const { email } = storeToRefs(clientStore);
  const { typePanier } = storeToRefs(checkoutStore);
  const { setStepValue, setTypePanier } = checkoutStore;


  const created = () => {
    setStepValue(3);
    setTypePanier(typePanier.value);
  }

  return {
    telephone,
    name,
    email,
    created
  }
}